export default __webpack_public_path__ + "static/media/AO.05126cc1.svg";